// @flow
import Modal from './SpinnerModal';

const MODAL_TYPE = 'SPINNER_MODAL';

export { Modal, MODAL_TYPE };
